"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayToCsv = exports.arrayToXlsx = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const properties_1 = require("../../hooks/condition/properties");
const lodash_1 = __importDefault(require("lodash"));
const locale_1 = require("utils/locale");
const quoteString = (str) => {
    return str; // `"${str.replace(/"/g, '""')}"`;
};
const stringifyForCSV = (item, isQuoteString = true) => {
    if (typeof item === "string") {
        return isQuoteString ? quoteString(item) : item;
    }
    else if (typeof item === "number" || typeof item === "boolean") {
        return item;
    }
    else if (Array.isArray(item)) {
        if (item.every((v) => typeof v === "string" || typeof v === "number")) {
            return isQuoteString ? quoteString(item.join(",")) : item.join(",");
        }
        else {
            return isQuoteString
                ? quoteString(JSON.stringify(item))
                : JSON.stringify(item);
        }
    }
    else if (item) {
        return isQuoteString
            ? quoteString(JSON.stringify(item))
            : JSON.stringify(item);
    }
    else {
        return "";
    }
};
const formatDateForCSV = (value, format) => {
    return typeof value === "number" ? (0, dayjs_1.default)(value).format(format) : "";
};
const iterateField = function* (schema, accessor, list) {
    var _a;
    // eslint-disable-next-line no-constant-condition
    if ((_a = schema.outputOptions) === null || _a === void 0 ? void 0 : _a.useRealFields) {
        const fields = new Set();
        for (const item of list) {
            for (const key of Object.keys(item)) {
                fields.add(key);
            }
        }
        for (const propertyName of Array.from(fields).sort()) {
            const propertyAccessor = (obj) => 
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            lodash_1.default.get(accessor(obj), propertyName);
            yield [{ propertyName }, propertyAccessor];
        }
    }
    else {
        for (const property of schema.properties) {
            const { propertyName, propertyId } = property;
            if (!propertyName && !propertyId) {
                continue;
            }
            const propertyNameOrId = (propertyName !== null && propertyName !== void 0 ? propertyName : propertyId);
            const propertyAccessor = (obj) => 
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            lodash_1.default.get(accessor(obj), propertyNameOrId);
            if (property.schema.schemaType === "object") {
                yield* iterateField(property.schema, propertyAccessor, list.map(propertyAccessor));
            }
            else {
                yield [property, propertyAccessor];
            }
        }
    }
};
const getCsvValue = (property, value, maxArrayLengthMap, parentValue) => {
    var _a;
    const schema = "schema" in property ? property.schema : undefined;
    const propertyNameOrId = ("propertyName" in property ? property.propertyName : property.propertyId);
    if ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "datetime") {
        return formatDateForCSV(value, "YYYY/MM/DD HH:mm:ss");
    }
    else if ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "date") {
        return formatDateForCSV(value, "YYYY/MM/DD");
    }
    else if ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "url") {
        if (schema.calc) {
            return (_a = schema.calc) === null || _a === void 0 ? void 0 : _a.call(schema, parentValue);
        }
        else {
            return stringifyForCSV(value);
        }
    }
    else if ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "textIntl" ||
        (schema === null || schema === void 0 ? void 0 : schema.schemaType) === "multilineTextIntl") {
        const multilangResults = locale_1.availableLocales.map((key) => {
            if (typeof value === "object" && value !== null) {
                return key in value
                    ? stringifyForCSV(value[key])
                    : "";
            }
            else {
                return key === "ja" ? stringifyForCSV(value) : "";
            }
        });
        return multilangResults.join(",");
    }
    else if ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "array") {
        const arrayValue = Array.isArray(value) ? value : [];
        const subSchema = schema.item;
        const maxArrayLength = maxArrayLengthMap.get(propertyNameOrId) || 0;
        const arrayResults = Array.from({ length: maxArrayLength }, (_, i) => {
            var _a;
            const subValue = (_a = arrayValue[i]) !== null && _a !== void 0 ? _a : {};
            return subSchema.properties.flatMap((property) => {
                const propertyNameOrId = ("propertyName" in property
                    ? property.propertyName
                    : property.propertyId);
                return getCsvValue(property, subValue[propertyNameOrId], maxArrayLengthMap, subValue);
            });
        });
        return arrayResults.join(",");
    }
    else {
        return stringifyForCSV(value);
    }
};
const getXlsxValue = (property, value, maxArrayLengthMap, parentValue, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
propertyList, isExpandMultipleSelector, isQuoteString = true, isJoinMaster = false, isConvertSelector = false, isConvertId = false) => {
    var _a, _b, _c, _d;
    const schema = "schema" in property ? property.schema : undefined;
    const propertyNameOrId = ("propertyName" in property ? property.propertyName : property.propertyId);
    if ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "datetime") {
        return formatDateForCSV(value, "YYYY/MM/DD HH:mm:ss");
    }
    else if ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "date") {
        return formatDateForCSV(value, "YYYY/MM/DD");
    }
    else if ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "url") {
        if (schema.calc) {
            return (_a = schema.calc) === null || _a === void 0 ? void 0 : _a.call(schema, parentValue);
        }
        else {
            return stringifyForCSV(value, isQuoteString);
        }
    }
    else if ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "textIntl" ||
        (schema === null || schema === void 0 ? void 0 : schema.schemaType) === "multilineTextIntl") {
        const multilangResults = locale_1.availableLocales.map((key) => {
            if (typeof value === "object" && value !== null) {
                return key in value
                    ? stringifyForCSV(value[key], isQuoteString)
                    : "";
            }
            else {
                return key === "ja" ? stringifyForCSV(value, isQuoteString) : "";
            }
        });
        return multilangResults;
        // } else if (isExpandMultipleSelector && schema?.schemaType === "selector") {
        //   const { options } = schema;
        //   return options.map((option) => {
        //     if (value === undefined) return "";
        //     return option.value === value;
        //   });
        // } else if (isExpandMultipleSelector && schema?.schemaType === "numberSelector") {
        //   const { minValue, maxValue } = schema;
        //   return Array.from({ length: maxValue - minValue + 1 }, (_, index) => {
        //     if (value === undefined) return "";
        //     return minValue + index === value;
        //   });
    }
    else if (isConvertSelector && (schema === null || schema === void 0 ? void 0 : schema.schemaType) === "selector") {
        const { options } = schema;
        if (options === undefined)
            return "";
        // optionsのvalueと一致するtitleを返す
        const option = options.find((option) => option.value === value);
        const convertedValue = (_b = (typeof (option === null || option === void 0 ? void 0 : option.title) === "object"
            ? option.title["ja"]
            : option === null || option === void 0 ? void 0 : option.title)) !== null && _b !== void 0 ? _b : "";
        return convertedValue;
    }
    else if (isExpandMultipleSelector &&
        (schema === null || schema === void 0 ? void 0 : schema.schemaType) === "multipleSelector") {
        const { options } = schema;
        if (options === undefined)
            return "";
        return options.map((option) => {
            const valueArray = Array.isArray(value) ? value : [];
            if (valueArray.length === 0)
                return "";
            return valueArray.includes(option.value) ? 1 : 0;
        });
    }
    else if (isConvertId &&
        ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "externalKey" ||
            (schema === null || schema === void 0 ? void 0 : schema.schemaType) === "multipleExternalKey")) {
        const property = propertyList.find((property) => property.propertyName === propertyNameOrId);
        const convertValue = (_d = (_c = property === null || property === void 0 ? void 0 : property.schema.options) === null || _c === void 0 ? void 0 : _c.find(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (option) => option.value === value)) === null || _d === void 0 ? void 0 : _d.title;
        return stringifyForCSV(convertValue, isQuoteString);
    }
    else if ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "array") {
        const arrayValue = Array.isArray(value) ? value : [];
        const subSchema = schema.item;
        const maxArrayLength = maxArrayLengthMap.get(propertyNameOrId) || 0;
        const arrayResults = Array.from({ length: maxArrayLength }, (_, i) => {
            var _a;
            const subValue = (_a = arrayValue[i]) !== null && _a !== void 0 ? _a : {};
            return subSchema.properties.flatMap((property) => {
                const propertyNameOrId = ("propertyName" in property
                    ? property.propertyName
                    : property.propertyId);
                return getXlsxValue(property, subValue[propertyNameOrId], maxArrayLengthMap, subValue, propertyList, isExpandMultipleSelector, isQuoteString, isJoinMaster, isConvertSelector, isConvertId);
            });
        });
        return arrayResults.length !== 0 ? arrayResults.flat() : "";
    }
    else if (propertyNameOrId === "createdAt" ||
        propertyNameOrId === "updatedAt") {
        // createdAtとupdatedAtは日付型のフォーマットに変換する
        return formatDateForCSV(value, "YYYY/MM/DD HH:mm:ss");
    }
    else {
        return stringifyForCSV(value, isQuoteString);
    }
};
const arrayToXlsx = (list, baseSchema, isQuoteString, isJoinMaster, isExpandMultipleSelector, isConvertSelector, isConvertId, isMinHeader) => __awaiter(void 0, void 0, void 0, function* () {
    const schema = baseSchema;
    const propertyList = yield (0, properties_1.getPropertyList)(baseSchema);
    console.log("propertyList", propertyList);
    const fields = Array.from(iterateField(schema, (v) => v, list));
    const maxArrayLengthMap = new Map(); // arraySchemaの最大長を記録する
    // propertyNameまたはpropertyIdの行を追加
    let idArray = [];
    const idConvertPrefix = "#";
    idArray = fields
        .map(([field, accessor]) => {
        const property = field;
        const { propertyName, propertyId, schema } = property;
        const propertyNameOrId = (propertyName !== null && propertyName !== void 0 ? propertyName : propertyId);
        if ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "textIntl" ||
            (schema === null || schema === void 0 ? void 0 : schema.schemaType) === "multilineTextIntl") {
            return locale_1.availableLocales.map((key) => {
                return `${propertyNameOrId}.${key}`;
            });
            // } else if (isExpandMultipleSelector && schema?.schemaType === "selector") {
            //   const { options } = schema;
            //   return [
            //     propertyNameOrId,
            //     ...Array.from({ length: options.length - 1 }).fill(""),
            //   ];
            // } else if (isExpandMultipleSelector && schema?.schemaType === "numberSelector") {
            //   const { minValue, maxValue } = schema;
            //   return [
            //     propertyNameOrId,
            //     ...Array.from({ length: maxValue - minValue }).fill(""),
            //   ];
        }
        else if (isConvertSelector && (schema === null || schema === void 0 ? void 0 : schema.schemaType) === "selector") {
            return `${idConvertPrefix}${propertyNameOrId}`;
        }
        else if (isExpandMultipleSelector &&
            (schema === null || schema === void 0 ? void 0 : schema.schemaType) === "multipleSelector") {
            const { options } = schema;
            if (options === undefined)
                return "";
            return [
                ...Array.from({ length: options.length }).fill(`${idConvertPrefix}${propertyNameOrId}`),
            ];
        }
        else if (isConvertId &&
            ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "externalKey" ||
                (schema === null || schema === void 0 ? void 0 : schema.schemaType) === "multipleExternalKey")) {
            return `${idConvertPrefix}${propertyNameOrId}`;
        }
        else if ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "array") {
            const subSchema = schema.item;
            const maxArrayLength = Math.max(...list.map((item) => {
                const value = accessor(item);
                return Array.isArray(value) ? value.length : 0;
            }));
            maxArrayLengthMap.set(propertyNameOrId, maxArrayLength);
            return maxArrayLength > 0
                ? Array.from({ length: maxArrayLength }, (_, i) => {
                    return subSchema.properties
                        .map((property) => {
                        const { schema } = property;
                        if (schema.schemaType === "textIntl" ||
                            schema.schemaType === "multilineTextIntl") {
                            return locale_1.availableLocales.map((_) => {
                                return "";
                            });
                            // } else if (
                            //   isExpandMultipleSelector &&
                            //   schema.schemaType === "selector"
                            // ) {
                            //   const { options } = schema;
                            //   return [
                            //     `${propertyNameOrId}.${i + 1}.${property.propertyName}`,
                            //     ...Array.from({ length: options.length - 1 }).fill(""),
                            //   ];
                            // } else if (
                            //   isExpandMultipleSelector &&
                            //   schema.schemaType === "numberSelector"
                            // ) {
                            //   const { minValue, maxValue } = schema;
                            //   return [
                            //     `${propertyNameOrId}.${i + 1}.${property.propertyName}`,
                            //     ...Array.from({ length: maxValue - minValue }).fill(""),
                            //   ];
                        }
                        else if (isExpandMultipleSelector &&
                            schema.schemaType === "multipleSelector") {
                            const { options } = schema;
                            if (options === undefined)
                                return "";
                            return [
                                `${propertyNameOrId}.${i + 1}.${property.propertyName}`,
                                ...Array.from({ length: options.length - 1 }).fill(""),
                            ];
                        }
                        return `${propertyNameOrId}.${i + 1}.${property.propertyName}`;
                    })
                        .flat();
                }).flat()
                : propertyNameOrId;
        }
        else {
            return propertyNameOrId;
        }
    })
        .flat();
    if (isJoinMaster || isExpandMultipleSelector)
        idArray.unshift("");
    // console.log("idArray", idArray);
    // titleの行を追加
    let titleArray = [];
    titleArray = fields
        .map(([field, accessor]) => {
        const property = field;
        const { propertyName, propertyId, schema, title, statShortName } = property;
        const propertyNameOrId = (propertyName !== null && propertyName !== void 0 ? propertyName : propertyId);
        if ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "textIntl" ||
            (schema === null || schema === void 0 ? void 0 : schema.schemaType) === "multilineTextIntl") {
            return locale_1.availableLocales.map((key) => {
                return `${title}(${locale_1.languageMapper[key]})`;
            });
            // } else if (isExpandMultipleSelector && schema?.schemaType === "selector") {
            //   const { options } = schema;
            //   return [
            //     statName || title,
            //     ...Array.from({ length: options.length - 1 }).fill(""),
            //   ];
            // } else if (isExpandMultipleSelector && schema?.schemaType === "numberSelector") {
            //   const { minValue, maxValue } = schema;
            //   return [
            //     statName || title,
            //     ...Array.from({ length: maxValue - minValue }).fill(""),
            //   ];
        }
        else if (isExpandMultipleSelector &&
            (schema === null || schema === void 0 ? void 0 : schema.schemaType) === "multipleSelector") {
            const { options } = schema;
            if (options === undefined)
                return "";
            return [
                ...Array.from({ length: options.length }).fill(statShortName || title),
            ];
        }
        else if ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "array") {
            const subSchema = schema.item;
            const maxArrayLength = maxArrayLengthMap.get(propertyNameOrId) || 0;
            return maxArrayLength > 0
                ? Array.from({ length: maxArrayLength }, (_, i) => {
                    return subSchema.properties
                        .map((property) => {
                        const { schema } = property;
                        if ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "textIntl" ||
                            (schema === null || schema === void 0 ? void 0 : schema.schemaType) === "multilineTextIntl") {
                            return locale_1.availableLocales.map((_) => {
                                return "";
                            });
                            // } else if (
                            //   isExpandMultipleSelector &&
                            //   schema.schemaType === "selector"
                            // ) {
                            //   const { options } = schema;
                            //   return [
                            //     `${title}.${i + 1}.${property.title}`,
                            //     ...Array.from({ length: options.length - 1 }).fill(""),
                            //   ];
                            // } else if (
                            //   isExpandMultipleSelector &&
                            //   schema.schemaType === "numberSelector"
                            // ) {
                            //   const { minValue, maxValue } = schema;
                            //   return [
                            //     `${title}.${i + 1}.${property.title}`,
                            //     ...Array.from({ length: maxValue - minValue }).fill(""),
                            //   ];
                        }
                        else if (isExpandMultipleSelector &&
                            schema.schemaType === "multipleSelector") {
                            const { options } = schema;
                            if (options === undefined)
                                return "";
                            return [
                                `${title}.${i + 1}.${property.title}`,
                                ...Array.from({ length: options.length - 1 }).fill(""),
                            ];
                        }
                        return `${title}.${i + 1}.${property.title}`;
                    })
                        .flat();
                }).flat()
                : statShortName || title;
        }
        else {
            return statShortName || title;
        }
    })
        .flat();
    titleArray.unshift("#title");
    // console.log("titleArray", titleArray);
    // optionを追加
    let optionArray = [];
    optionArray = fields
        .map(([field, accessor]) => {
        const property = field;
        const { propertyName, propertyId, schema, title, statName } = property;
        const propertyNameOrId = (propertyName !== null && propertyName !== void 0 ? propertyName : propertyId);
        if ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "textIntl" ||
            (schema === null || schema === void 0 ? void 0 : schema.schemaType) === "multilineTextIntl") {
            return locale_1.availableLocales.map((_) => {
                return "";
            });
            // } else if (schema?.schemaType === "selector") {
            //   const { options } = schema;
            //   return options.map((option) => {
            //     return option.value;
            //   });
            // } else if (schema?.schemaType === "numberSelector") {
            //   const { minValue, maxValue } = schema;
            //   return Array.from(
            //     { length: maxValue - minValue + 1 },
            //     (_, index) => minValue + index
            //   );
        }
        else if ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "multipleSelector") {
            const { options } = schema;
            if (options === undefined)
                return "";
            return options.map((option) => {
                return option.value;
            });
        }
        else if ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "array") {
            const subSchema = schema.item;
            const maxArrayLength = maxArrayLengthMap.get(propertyNameOrId) || 0;
            return maxArrayLength > 0
                ? Array.from({ length: maxArrayLength }, (_, i) => {
                    return subSchema.properties
                        .map((property) => {
                        const { schema } = property;
                        if ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "textIntl" ||
                            (schema === null || schema === void 0 ? void 0 : schema.schemaType) === "multilineTextIntl") {
                            return locale_1.availableLocales.map((_) => {
                                return "";
                            });
                            // } else if (schema.schemaType === "selector") {
                            //   const { options } = schema;
                            //   return options.map((option) => {
                            //     return option.value;
                            //   });
                            // } else if (schema.schemaType === "numberSelector") {
                            //   const { minValue, maxValue } = schema;
                            //   return Array.from(
                            //     { length: maxValue - minValue + 1 },
                            //     (_, index) => minValue + index
                            //   );
                        }
                        else if (schema.schemaType === "multipleSelector") {
                            const { options } = schema;
                            if (options === undefined)
                                return "";
                            return options.map((option) => {
                                return option.value;
                            });
                        }
                        else {
                            return "";
                        }
                    })
                        .flat();
                }).flat()
                : "";
        }
        else {
            return "";
        }
    })
        .flat();
    optionArray.unshift("#option");
    // console.log("optionArray", optionArray);
    // option.titleを追加
    let optionTitleArray = [];
    optionTitleArray = fields
        .map(([field, accessor]) => {
        const property = field;
        const propertyNameOrId = ("propertyName" in property ? property.propertyName : property.propertyId);
        const { schema } = property;
        if ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "textIntl" ||
            (schema === null || schema === void 0 ? void 0 : schema.schemaType) === "multilineTextIntl") {
            return locale_1.availableLocales.map((_) => {
                return "";
            });
            // } else if (schema?.schemaType === "selector") {
            //   const { options } = schema;
            //   return options.map((option) => {
            //     return option.title;
            //   });
            // } else if (schema?.schemaType === "numberSelector") {
            //   const { minValue, maxValue, textBefore, textAfter } = schema;
            //   return [
            //     textBefore || "",
            //     ...Array.from({ length: maxValue - minValue - 1 }).fill(""),
            //     textAfter || "",
            //   ];
        }
        else if ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "multipleSelector") {
            const { options } = schema;
            if (options === undefined)
                return "";
            return options.map((option) => {
                return option.title;
            });
        }
        else if ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "array") {
            console.log("array", { propertyNameOrId, schema });
            const subSchema = schema.item;
            const maxArrayLength = maxArrayLengthMap.get(propertyNameOrId) || 0;
            return maxArrayLength > 0
                ? subSchema.properties
                    .map((property) => {
                    const { schema } = property;
                    if ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "textIntl" ||
                        (schema === null || schema === void 0 ? void 0 : schema.schemaType) === "multilineTextIntl") {
                        return locale_1.availableLocales.map((_) => {
                            return "";
                        });
                        // } else if (
                        //   isExpandMultipleSelector &&
                        //   schema.schemaType === "selector"
                        // ) {
                        //   const { options } = schema;
                        //   return options.map((option) => {
                        //     return option.title;
                        //   });
                        // } else if (
                        //   isExpandMultipleSelector &&
                        //   schema.schemaType === "numberSelector"
                        // ) {
                        //   const { minValue, maxValue, textBefore, textAfter } = schema;
                        //   return [
                        //     textBefore || "",
                        //     ...Array.from({ length: maxValue - minValue - 1 }).fill(""),
                        //     textAfter || "",
                        //   ];
                    }
                    else if (isExpandMultipleSelector &&
                        schema.schemaType === "multipleSelector") {
                        const { options } = schema;
                        if (options === undefined)
                            return "";
                        return options.map((option) => {
                            return option.title;
                        });
                    }
                    else {
                        return "";
                    }
                })
                    .flat()
                : "";
        }
        else {
            return "";
        }
    })
        .flat();
    optionTitleArray.unshift("#option.title");
    // console.log("optionTitleArray", optionTitleArray);
    // title + option.titleの行を追加
    let titleAndOptionTitleArray = [];
    titleAndOptionTitleArray = fields
        .map(([field, accessor]) => {
        const property = field;
        const { propertyName, propertyId, schema, title, statShortName } = property;
        const propertyNameOrId = (propertyName !== null && propertyName !== void 0 ? propertyName : propertyId);
        if ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "textIntl" ||
            (schema === null || schema === void 0 ? void 0 : schema.schemaType) === "multilineTextIntl") {
            return locale_1.availableLocales.map((key) => {
                return `${title}(${locale_1.languageMapper[key]})`;
            });
        }
        else if (isExpandMultipleSelector &&
            (schema === null || schema === void 0 ? void 0 : schema.schemaType) === "multipleSelector") {
            const { options } = schema;
            if (options === undefined)
                return "";
            return options.map((option) => {
                const optionTitle = typeof option.title === "object"
                    ? option.title["ja"]
                    : option.title;
                return `${statShortName || title}_${optionTitle}`;
            });
        }
        else if ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "array") {
            const subSchema = schema.item;
            const maxArrayLength = maxArrayLengthMap.get(propertyNameOrId) || 0;
            return maxArrayLength > 0
                ? Array.from({ length: maxArrayLength }, (_, i) => {
                    return subSchema.properties
                        .map((property) => {
                        const { schema } = property;
                        if ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "textIntl" ||
                            (schema === null || schema === void 0 ? void 0 : schema.schemaType) === "multilineTextIntl") {
                            return locale_1.availableLocales.map((_) => {
                                return "";
                            });
                        }
                        else if (isExpandMultipleSelector &&
                            schema.schemaType === "multipleSelector") {
                            const { options } = schema;
                            if (options === undefined)
                                return "";
                            return options.map((option) => {
                                const optionTitle = typeof option.title === "object"
                                    ? option.title["ja"]
                                    : option.title;
                                return `${statShortName || title}.${i + 1}.${property.title}_${optionTitle}`;
                            });
                        }
                        return `${title}.${i + 1}.${property.title}`;
                    })
                        .flat();
                }).flat()
                : statShortName || title;
        }
        else {
            return statShortName || title;
        }
    })
        .flat();
    if (!isMinHeader)
        titleAndOptionTitleArray.unshift("#title_option.title");
    // console.log("titleAndOptionTitleArray", titleAndOptionTitleArray);
    // dataを追加
    const dataArray = [];
    for (const item of list) {
        const row = fields
            .map(([property, accessor]) => {
            const value = accessor(item);
            return getXlsxValue(property, value, maxArrayLengthMap, item, propertyList, isExpandMultipleSelector, isQuoteString, isJoinMaster, isConvertSelector, isConvertId);
        })
            .flat();
        if (!isMinHeader && (isJoinMaster || isExpandMultipleSelector))
            row.unshift("");
        dataArray.push(row);
    }
    // console.log("dataArray", dataArray);
    return [
        !isMinHeader ? idArray : [],
        !isMinHeader && isJoinMaster ? titleArray : [],
        !isMinHeader && isExpandMultipleSelector ? optionArray : [],
        !isMinHeader && isJoinMaster && isExpandMultipleSelector
            ? optionTitleArray
            : [],
        isMinHeader || (isJoinMaster && isExpandMultipleSelector)
            ? titleAndOptionTitleArray
            : [],
        ...dataArray,
    ].filter((array) => array.length !== 0);
});
exports.arrayToXlsx = arrayToXlsx;
const arrayToCsv = (list, schema) => {
    console.log({ schema });
    const fields = Array.from(iterateField(schema, (v) => v, list));
    const maxArrayLengthMap = new Map(); // arraySchemaの最大長を記録する
    // propertyNameまたはpropertyIdの行を追加
    let output = ",";
    output +=
        fields
            .map(([field, accessor]) => {
            const property = field;
            const { propertyName, propertyId, schema } = property;
            const propertyNameOrId = (propertyName !== null && propertyName !== void 0 ? propertyName : propertyId);
            if ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "textIntl" ||
                (schema === null || schema === void 0 ? void 0 : schema.schemaType) === "multilineTextIntl") {
                return locale_1.availableLocales
                    .map((key) => {
                    return `${propertyNameOrId}.${key}`;
                })
                    .join(",");
            }
            else if ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "array") {
                const subSchema = schema.item;
                const maxArrayLength = Math.max(...list.map((item) => {
                    const value = accessor(item);
                    return Array.isArray(value) ? value.length : 0;
                }));
                maxArrayLengthMap.set(propertyNameOrId, maxArrayLength);
                return maxArrayLength > 0
                    ? Array.from({ length: maxArrayLength }, (_, i) => subSchema.properties
                        .map((property) => `${propertyNameOrId}.${i + 1}.${property.propertyName}`)
                        .join(",")).join(",")
                    : propertyNameOrId;
            }
            return propertyNameOrId;
        })
            .join(",") + "\n";
    // titleの行を追加
    output += "#title,";
    output +=
        fields
            .map(([field, accessor]) => {
            const property = field;
            const { propertyName, propertyId, schema, title } = property;
            const propertyNameOrId = (propertyName !== null && propertyName !== void 0 ? propertyName : propertyId);
            if ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "textIntl" ||
                (schema === null || schema === void 0 ? void 0 : schema.schemaType) === "multilineTextIntl") {
                return locale_1.availableLocales
                    .map((key) => {
                    return `${title}(${locale_1.languageMapper[key]})`;
                })
                    .join(",");
            }
            else if ((schema === null || schema === void 0 ? void 0 : schema.schemaType) === "array") {
                const subSchema = schema.item;
                const maxArrayLength = maxArrayLengthMap.get(propertyNameOrId) || 0;
                return maxArrayLength > 0
                    ? subSchema.properties.map((property) => {
                        return `${title}(${property.title})`;
                    })
                    : title;
            }
            else {
                return title;
            }
        })
            .join(",") + "\n";
    // dataを追加
    for (const item of list) {
        output += ",";
        output +=
            fields
                .map(([property, accessor]) => {
                const value = accessor(item);
                return getCsvValue(property, value, maxArrayLengthMap, item);
            })
                .join(",") + "\n";
    }
    return output;
};
exports.arrayToCsv = arrayToCsv;
